import React, { Component, Fragment } from 'react';
import {
    Input,
    Button,
    Row,
    Col,
} from 'reactstrap';
import './Notes.css';
import { Prompt } from 'react-router-dom';

// import NotesCategoriesDisplay from './NotesCategoriesDisplay';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faPlus, faTimes, faSpinner } from '@fortawesome/free-solid-svg-icons'
// import PermissionWrapper from '../../../auth/PermissionWrapper';

class AddContactsNote extends Component {

    constructor(props) {
        super(props);
        this.state = {
            displayCategories: this.props.displayCategories,
            add: false,
            date: new Date().toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/(\d+)\/(\d+)\/(\d+)/, '$1-$2-$3'),
            typeID: 0,
            notes: '',
            unsavedChanges: false,
        };
    }

    addNote = () => {
        this.props.addNote(this.state.date, this.state.typeID, this.state.notes, () => {
            this.setState({
                date: new Date().toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/(\d+)\/(\d+)\/(\d+)/, '$1-$2-$3'),
                typeID: 0,
                notes: '',
                add: false,
                unsavedChanges: false
            })
        });
    }

    render() {
        return (this.state.add ? <>
            <Prompt
                when={this.state.unsavedChanges}
                message="You have unsaved changes, are you sure you want to leave?"
            />
            <Row className='mt-4'>
                <Col className='pr-2'>
                    <Input
                        type="date"
                        name="date"
                        value={this.state.date}
                        onChange={(e) => this.setState({ date: e.target.value, unsavedChanges: true })}
                    />
                </Col>
                <Col className='pl-0'>
                    {this.props.addCategorySubCommentsArray && this.props.addCategorySubCommentsArray.map(row => {
                        switch (row.validation) {
                            case "list":
                                return (
                                    <Fragment key={row.ID}>
                                        <Input type="select"
                                            name="typeID"
                                            value={this.state.typeID}
                                            onChange={(e) => this.setState({ typeID: parseInt(e.target.value), unsavedChanges: true })}
                                        >
                                            <option value="0">ACTIVITY</option>
                                            {row.list != null && row.list
                                                .filter(item => item.longDescription !== 'Other')
                                                .map(item => (
                                                    <option key={item.ID} value={item.ID}>{item.longDescription}</option>
                                                ))}
                                        </Input>
                                    </Fragment>
                                )
                            default:
                                return (
                                    <></>
                                )
                        }
                    })}
                </Col>
            </Row>
            <Row className='mt-2'>
                <Col>
                    <Input
                        type="textarea"
                        name="notes"
                        rows={15}
                        value={this.state.notes}
                        onChange={(e) => this.setState({ notes: e.target.value, unsavedChanges: true })}
                    />
                </Col>
            </Row>
            <Row className='mt-2'>
                <Col>
                    <Button
                        color="success"
                        onClick={this.addNote}
                    >
                        Save
                    </Button>
                    <Button
                        color="secondary"
                        className='ml-2'
                        onClick={() => this.setState({ add: false, unsavedChanges: false })}
                    >
                        Cancel
                    </Button>
                </Col>
            </Row>
        </> :
            <Row className='mt-4'>
                <Col>
                    <Button
                        color="primary"
                        onClick={() => this.setState({ add: true })}
                    >
                        Add Contacts Note
                    </Button>
                </Col>
            </Row>
        )
    }
}

export default AddContactsNote;
